import { Cell, Grid, Heading, useTheme } from 'bold-ui'

import { MarcadoresConsumoAlimentarListItem } from '../MarcadoresConsumoAlimentarListItem'
import { MCAMenoresDeSeisMesesPanelModel, mcaMenoresDeSeisMesesQuestions, MCAProps } from '../model'
import { createStyles } from '../utils'
import { SimNaoNaoSabeRadioGroupField } from './SimNaoNaoSabeRadioGroupField'

const filter = ['leiteMaterno']
const filteredQuestions = Object.entries(mcaMenoresDeSeisMesesQuestions).filter(([key, _]) => !filter.includes(key))

export function MCAMenoresDeSeisMeses(props: MCAProps<MCAMenoresDeSeisMesesPanelModel>) {
  const { name } = props
  const theme = useTheme()
  const style = createStyles(theme)

  return (
    <>
      <Grid>
        <Cell size={12} style={style.border}>
          <MarcadoresConsumoAlimentarListItem label={mcaMenoresDeSeisMesesQuestions.leiteMaterno}>
            <SimNaoNaoSabeRadioGroupField name={name.leiteMaterno} showErrorField={false} />
          </MarcadoresConsumoAlimentarListItem>
        </Cell>
      </Grid>
      <Grid>
        <Cell size={12} style={style.sectionHeading}>
          <Heading level={6}>Ontem a criança consumiu:</Heading>
        </Cell>
        {filteredQuestions.map(([key, value]) => (
          <Cell key={key} size={12} style={style.border}>
            <MarcadoresConsumoAlimentarListItem label={value}>
              <SimNaoNaoSabeRadioGroupField name={name[key]} showErrorField={false} />
            </MarcadoresConsumoAlimentarListItem>
          </Cell>
        ))}
      </Grid>
    </>
  )
}
